import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

interface Props {
  data: { menuName: string; quantity: number; sales: number }[];
  height?: number;
  maxItems?: number;
}

export const ProductBarChart = ({ data, height = 360, maxItems = 15 }: Props) => {
  const top = data.slice(0, maxItems);
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={top} layout="vertical" margin={{ top: 8, right: 16, bottom: 0, left: 16 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
        <XAxis
          type="number"
          tick={{ fontSize: 11 }}
          tickFormatter={(v: number) =>
            v >= 10000 ? `${(v / 10000).toFixed(0)}万` : v.toLocaleString()
          }
        />
        <YAxis
          dataKey="menuName"
          type="category"
          tick={{ fontSize: 11 }}
          width={140}
          interval={0}
        />
        <Tooltip
          formatter={(v) => `¥${Number(v).toLocaleString()}`}
        />
        <Bar dataKey="sales" name="売上" fill="#aa0b56" />
      </BarChart>
    </ResponsiveContainer>
  );
};
